import ITown from "../interfaces/ITown";
import ArrayTransformer from "./ArrayTransformer";

class Town {
    public static calculateTownsCenterPosition(towns: ITown[]): { lat: number, lng: number } {
        const townsWithoutPositionDuplication : ITown[] = [];

        towns.forEach(town => {
            const exist = townsWithoutPositionDuplication.some(t => t.insee === town.insee);

            if (!exist) {
                townsWithoutPositionDuplication.push(town);
            }
        });

        const positions: [number , number][] = townsWithoutPositionDuplication.map(town => [town.lat ?? 0, town.lng ?? 0]);
        const sum = positions.reduce((acc, value) => {
            return [
                Number(acc[0]) + Number(value[0]),
                Number(acc[1]) + Number(value[1])
            ];
        }, [0,0]);

        return { lat: sum[0] / positions.length, lng: sum[1] / positions.length };
    }

    public static invertLatLng(town : ITown): ITown {
        if (town.geoJson) {
            town.geoJson.coordinates = ArrayTransformer.LatLngTransformer(town.geoJson.coordinates);
        }

        return town;
    }
}

export default Town;
